import React, { useEffect, useState } from 'react'
import SideBar from '../Sidebar/SideBar'
import BannerApi from '../../Api/BannerApi';
import ImageApi from '../../Api/Image'
import { Icon } from '@iconify/react/dist/iconify.js';
import BannerScheduleModal from '../Models/bannerschedulemodal';
import BannerScheduleApi from '../../Api/BannerScheduleApi';
import Swal from "sweetalert2";


const Banner = () => {
    const [bannerData, setBannerData] = useState([]);
    const [selectedBannerId, setSelectedBannerId] = useState(null);
    const [itemId, setItemId] = useState('');
    const [imageUrls, setImageUrls] = useState({});
    const [inputValues, setInputValues] = useState({
        Name: '',
        Url: '',
        priority: '',
        file: '',
    });
    const [isModalOpen, setIsModalOpen] = useState(false);

    // Function to handle opening the modal
    const openModal = (bannerId) => {
        setSelectedBannerId(bannerId);
        setIsModalOpen(true);
    };

    // Function to handle closing the modal
    const closeModal = () => {
        setIsModalOpen(false);
    };
    const handleChange = (e) => {
        const { name, value, files } = e.target;

        if (name === "file") {
            setInputValues((prevValues) => ({
                ...prevValues,
                [name]: files[0],
            }));
        } else {
            setInputValues((prevValues) => ({
                ...prevValues,
                [name]: value,
            }));
        }
    };

    const handleSave = async () => {
        try {
            const response = await BannerApi.CreateAppReleaseServer(inputValues)
            if (response.StatusCode === 201) {
                setInputValues({
                    Name: '',
                    Url: '',
                    priority: '',
                    file: '',
                })
                Swal.fire({ title: "Saved", text: "Saved Successfully", icon: "success", width: "320px" })
                fetchdata()
            }
        } catch (error) {
            console.error(error);
        }
    }

    const handleUpdate = async () => {
        try {
            const response = await BannerApi.UpdateAppReleaseServer(itemId, inputValues)
            if (response.StatusCode === 200) {
                setInputValues({
                    Name: '',
                    Url: '',
                    priority: '',
                    file: '',
                })
                Swal.fire({ title: "Updated", text: "Updated Successfully", icon: "success", width: "320px" })
                fetchdata()
            }
        } catch (error) {
            console.error(error);
        }
    }

    const fetchdata = async () => {
        try {
            const response = await BannerApi.GetAppReleaseServer()
            if (response.StatusCode === 200) {
                console.log(response.Result);
                setBannerData(response.Result)
            }
        } catch (error) {
            console.error(error);
        }
    }

    const fetchimage = async (id) => {
        try {
            
            const response = await ImageApi.GetImageById(id)
            if (response) {
                console.log(response);
                const url = URL.createObjectURL(response);
                setImageUrls((prevUrls) => ({
                    ...prevUrls,
                    [id]: url
                }));
            }
        } catch (error) {
            console.error(error);
        }
    }

    useEffect(() => {
        bannerData.forEach((item) => {
            if (item.BannerImg && !imageUrls[item.BannerImg]) {
                fetchimage(item.BannerImg);
            }
        });

        return () => {
            Object.values(imageUrls).forEach((url) => URL.revokeObjectURL(url));
        };
    }, [bannerData, imageUrls]);

    useEffect(() => {
        fetchdata()
    }, []);


    const handleEdit = (item) => {
        console.log("item", item);
        setItemId(item.id)

        setInputValues({
            Name: item.Name,
            Url: item.Url,
            priority: item.priority,

        })

        console.log(`Edit item with id ${item.id}`);
    };

    const saveData = async (data) => {
        console.log("Data saved: ", data);
        const scheduleData = {
            date_range: `${data.start_date},${data.end_date}`,
            product_category: data.product_category,
            applicable_states: data.applicable_states.join(","),
            bannerId: data.bannerId,
        }
        console.log("scheduleData", scheduleData);

        try {
            const response = await BannerScheduleApi.Create(scheduleData)
            if (response.StatusCode === 201) {
                Swal.fire({ title: "Scheduled", text: "Scheduled Successfully", icon: "success", width: "320px" })
                closeModal();
                return response;
            }
        } catch (error) {
            console.error(error)
        }
        closeModal();
    };

    return (
        <div className='Flex-general-client-sidebar'>
            <div className='sidebar-gen-width'>
                <SideBar />
            </div>
            <div className='Main-general-Client'>
                <div className='header-general'>
                    <h2 className='general-card-title'>Banner Master</h2>
                </div>
                <div className="control_radius">
                    {/* <div className="company_info-text-im depart_top">Report Template Setting</div> */}
                    <div className="company_control">
                        <div className="stock-im-dep1">
                            <div className="input-box-Imo1">
                                <div className="input-box-mok1">
                                    <input className="modify_im_input mode_category1"
                                        type="text" name="Name" onChange={handleChange} value={inputValues.Name} required />
                                    <label class="modify_p_text2">Banner Name</label>
                                </div>
                            </div>
                        </div>
                        <div className="stock-im-dep1">
                            <div className="input-box-Imo1 input-height2">
                                <div className="input-box-mok1">
                                    <input className="modify_im_input mode_category1"
                                        type="text" name="Url" onChange={handleChange} value={inputValues.Url} required />
                                    <label class="modify_p_text2">Url</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="company_control">
                        <div className="stock-im-dep1">
                            <div className="input-box-Imo1 input-height2">
                                {/* <div className="input-box-mok1">
                                    <label class="modify_lbl_text3">Priority</label>
                                    <input className="modify_im_input mode_category1"
                                        type="text" name="priority" value={inputValues.priority} onChange={handleChange} required />
                                </div> */}
                                <div className="input-box-mok1">
                                    <input className="modify_im_input mode_category1"
                                        min="1"
                                        type="number" name="priority" onChange={handleChange} value={inputValues.priority} required />
                                    <label class="modify_p_text2">Priority</label>
                                </div>
                            </div>
                        </div>
                        <div className="stock-im-dep1">
                            <div className="input-box-Imo1 input-height2">
                                <div className="input-box-mok1">
                                    <label class="modify_lbl_text3">Banner Image</label>
                                    <input className="modify_im_input mode_category1"
                                        type="file" name="file" onChange={handleChange} required />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="ButtonTabSave">


                        {
                            itemId ? (
                                <button
                                    id="SaveBtnMain"
                                    className={`update-button-main-save hovered`}
                                    onClick={handleUpdate}
                                >
                                    Update
                                </button>
                            ) : (
                                <button
                                    id="SaveBtnMain"
                                    className={`save-button-main-save hovered`}
                                    onClick={handleSave}
                                >
                                    Save
                                </button>
                            )
                        }




                    </div>

                    <div className="company_info-text-im depart_top">Banner List</div>
                    <div className="control_radius">
                        <div className="table-account-manager">
                            <table className='table-master-acc'>
                                <thead className='header-table-account'>
                                    <tr>
                                        <th className='table-header-manager ac-sno-wth'>S.No</th>
                                        <th className='table-header-manager'>Id</th>
                                        <th className='table-header-manager'>Name</th>
                                        <th className='table-header-manager'> Url</th>
                                        <th className='table-header-manager'>Priority</th>
                                        <th className='table-header-manager'>Banner Image</th>

                                        <th className='table-header-manager'>Creation Date</th>
                                        <th className='table-header-manager'>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {bannerData && bannerData.map((item, idx) => (
                                        <tr key={item.id}>
                                            <td className='table-data-account ac-sno-wth'>{idx + 1}</td>
                                            <td className='table-data-account'>{item.id}</td>
                                            <td className='table-data-account'>{item.Name}</td>
                                            <td className='table-data-account'>{item.Url}</td>
                                            <td className='table-data-account'>{item.priority}</td>
                                            <td className='table-data-account'>
                                                <img
                                                    src={imageUrls[item.BannerImg]}
                                                    alt={`Banner ${item.BannerImg}`}
                                                    width={100}
                                                    height={40}
                                                />
                                            </td>

                                            <td className='table-data-account'>{item.cr_dt.split("T")[0]}</td>
                                            <td className='table-data-account'>
                                                <button className="edit-btn-acc"
                                                    onClick={() => openModal(item.id)}
                                                ><Icon icon="grommet-icons:schedule" />
                                                </button>

                                                <button className="edit-btn-acc"

                                                    onClick={() => handleEdit(item)}
                                                ><Icon icon="lucide:edit" /></button>
                                                <button className="delete-btn-acc"
                                                // onClick={() => handleDelete(item.id)}
                                                ><Icon icon="material-symbols:delete" /></button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>

                            {
                                isModalOpen && (
                                    <BannerScheduleModal
                                        isOpen={isModalOpen}
                                        onClose={closeModal}
                                        onSave={saveData}
                                        BannerId={selectedBannerId}
                                    />
                                )
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Banner
